<template>
  <draggable :list="colonnes" @change="handleDrag" handle=".move-action" :group="'colonneList'+conindex">
    <colonne
      v-for="(el, colindex) in colonnes" :key="'colonne-'+colindex"
      :col-data="el"
      :col-index="colindex"
      :con-index="conindex"
    ></colonne>
  </draggable>
</template>

<script>
import colonne from './colonne'
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
export default {
  components: {
    draggable,
    colonne
  },
  props: {
    colonnes: {
      type: Array,
      required: true
    },
    conindex: Number
  },
  methods: {
    ...mapActions(['updateColonneOrder']),
    handleDrag () {
      this.updateColonneOrder({conindex: this.conindex, value: this.colonnes})
    }
  }
}
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/listColonne.vue